import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
import TableOfContents from "../TableOfContents/TableOfContents.tsx";
import TocMobile from "../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./Attribution.css";
// import the separated file related to the component
import TextAttribution from "./TextAttribution";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";
const Attribution = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "Team",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "Team",
    },
    {
      level: 2,
      text: "Supervisors",
      id: "Supervisors",
    },
    {
      level: 2,
      text: "External people",
      id: "External-People",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Laboratory infrastructure and supply",
      id: "lab",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Education and Communication",
      id: "education",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Human Practices",
      id: "HP",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Safety protocols",
      id: "safety",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Collaborations",
      id: "other teams",
    },
    {
      level: 3,
      text: "Financial facilitator",
      id: "financial",
    },
    {
      level: 3,
      text: "The Unclassifiable",
      id: "unclassifiable",
    },
    {
      level: 2,
      text: "Sponsors",
      id: "sponsors",
    },

    {
      level: 2,
      text: "Attributions form",
      id: "igem-attribution-form",
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds

    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setDisplayNavBar(!loading);
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar]);

  return (
    <>
      <div className="relative">
        {loading ? (
          <div className="spinner-container fixed h-screen w-screen bg-white z-10">
            <RingLoader color="#BA55D3" loading={loading} />{" "}
            <script>{(document.body.style.overflow = "hidden")}</script>
          </div>
        ) : (
          <script>{(document.body.style.overflow = "auto")}</script>
        )}
        <>
          <div className="top-page">
            <h1>Attributions</h1>
          </div>
          <div
            className="grid grid-cols-12 gap-4"
            style={{ marginRight: "4rem", marginLeft: "4rem" }}
          >
            <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
              <div className="sticky top-4 scrollable">
                <TableOfContents headings={headingsData} />
              </div>
            </div>
            <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
              <TextAttribution />
            </main>
            <div className="md:hidden col-span-12 order-3 TOCstyle">
              <TocMobile headings={headingsData} />
            </div>
          </div>
        </>{" "}
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Attribution, "attribution");
